import Text from "./Text";

const ErrorText = ({
  children,
  isOnDarkBg,
}: {
  children: string;
  isOnDarkBg?: boolean;
}): JSX.Element => {
  return (
    <Text className={` ${isOnDarkBg ? "text-ldir-red-700" : "text-ldir-red-900"}`}>{children}</Text>
  );
};

export default ErrorText;
